<ng-container *transloco="let t; prefix: 'anc.shared.footer'">
  <footer class="ft">
    <div class="ft-line" aria-hidden="true"></div>
    <div class="ft-in">
      <div class="ft-top">
        <div class="ft-brand">
          <img src="/brand/ancelade-logo-white.svg" alt="Ancelade" width="170" height="44" />
          <p class="ft-claim">{{ t('claim') }}</p>
          <div class="ft-pills">
            @if (operational() !== null) {
              <a class="ft-pill" [routerLink]="href('/status')">
                <i class="ft-live" [class.is-degraded]="!operational()" aria-hidden="true"></i>
                {{ operational() ? t('statusOk') : t('statusKo') }}
              </a>
            }
            <a class="ft-pill" href="https://fr.trustpilot.com/review/privateheberg.net" target="_blank" rel="noopener">
              <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                <path fill="#00B67A" d="m12 1.5 2.7 8.2h8.6l-7 5.1 2.7 8.2-7-5.1-7 5.1 2.7-8.2-7-5.1h8.6Z" />
              </svg>
              {{ t('trustpilot') }}
            </a>
          </div>
        </div>
        <div class="ft-contact">
          <a class="ft-c" href="tel:+33184754308"
            ><span>{{ t('salesLabel') }}</span
            ><b>+33 1 84 75 43 08</b><em aria-hidden="true">→</em></a
          >
          <a class="ft-c" href="mailto:contact@ancelade.com"
            ><span>{{ t('writeLabel') }}</span
            ><b>contact&#64;ancelade.com</b><em aria-hidden="true">→</em></a
          >
          <a class="ft-c" [routerLink]="href('/datacenter')"
            ><span>{{ t('datacenterLabel') }}</span
            ><b>{{ t('datacenterPlace') }}</b
            ><em aria-hidden="true">→</em></a
          >
        </div>
      </div>

      <nav class="ft-cols" [attr.aria-label]="t('sitemap')">
        @for (column of columns(); track column.key) {
          <div class="ft-col" [class]="'u-' + column.key">
            <b><i aria-hidden="true"></i>{{ column.name }}</b>
            @for (entry of column.links; track entry.label) {
              <a [routerLink]="href(entry.link)" [queryParams]="entry.link.queryParams">{{ entry.label }}</a>
            }
          </div>
        }
        <div class="ft-col">
          <b><i class="dot-white" aria-hidden="true"></i>Ancelade</b>
          <a [routerLink]="href('/about')">{{ t('company') }}</a>
          <a [routerLink]="home()" fragment="migration">{{ t('migration') }}</a>
          <a [routerLink]="home()" fragment="avis">{{ t('reviews') }}</a>
          <a [href]="panelUrl">{{ t('clientArea') }}</a>
        </div>
      </nav>

      <div class="ft-bottom">
        <span>{{ t('copyright', { year }) }}</span>
        <span class="ft-legal">
          <a [routerLink]="href('/mentions-legales')">{{ t('legalNotice') }}</a>
          <a [routerLink]="href('/cgu')">{{ t('terms') }}</a>
          <a [routerLink]="href('/confidentialite')">{{ t('privacy') }}</a>
        </span>
        <span class="ft-legal">
          <a href="https://discord.gg/XmMr4nVusW" target="_blank" rel="noopener noreferrer">Discord</a>
          <span class="current" aria-current="true" [attr.lang]="lang()">{{ lang() | uppercase }}</span>
          <a
            [href]="otherHome()"
            [attr.hreflang]="otherLang()"
            [attr.lang]="otherLang()"
            [attr.aria-label]="otherLabel()"
            (click)="switchLang($event)"
            >{{ otherLang() | uppercase }}</a
          >
        </span>
      </div>
    </div>
    <div class="ft-word" aria-hidden="true">ancelade</div>
  </footer>
</ng-container>
